import React from "react"
import Section from "../../section.component"
import styled from "styled-components"
import { ReviewsEmbedGridConfig } from "./reviews-embed-grid.interface"

const ReviewsEmbedGrid = ({ config }: { config: ReviewsEmbedGridConfig }) => {
  console.log(config)
  return (
    <ReviewsEmbedGridSection>
      <TitleContainer>
        <Title>{config.reviewsGrid.title}</Title>
        <Subtitle>{config.reviewsGrid.subTitle}</Subtitle>
      </TitleContainer>
      <GridContainer>
        {config.reviewsGrid.embedIds.map((embedId) => (
          <GridItem key={embedId}>
            <iframe
              height="350"
              src={`https://www.youtube.com/embed/${embedId}`}
              title="YouTube video player"
              allowFullScreen
            />
          </GridItem>
        ))}
      </GridContainer>
    </ReviewsEmbedGridSection>
  )
}

export default ReviewsEmbedGrid

const ReviewsEmbedGridSection = styled(Section)`
  padding: 64px 0;
`

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 24px;
  max-width: 900px;
  margin: 0 auto;
  margin-bottom: 80px;

  @media (max-width: ${({ theme }) =>
      theme.breakpoint.tabletHorizontal - 1}px) {
    margin-bottom: 48px;
  }
`

const Title = styled.h2`
  text-align: center;

  /* Heading/H1 */
  font-family: Facto;
  font-size: 37px;
  font-style: normal;
  font-weight: 400;
  margin: 0;

  @media (max-width: ${({ theme }) =>
      theme.breakpoint.tabletHorizontal - 1}px) {
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
  }
`

const Subtitle = styled.h3`
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  margin: 0;

  @media (max-width: ${({ theme }) =>
      theme.breakpoint.tabletHorizontal - 1}px) {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
  }
`

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 350px);
  gap: 32px;
  overflow: hidden;

  @media (max-width: ${({ theme }) =>
      theme.breakpoint.tabletHorizontal - 1}px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, 220px);
    gap: 24px;
  }
`

const GridItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  background-color: ${({ theme }) => theme.color.backgroundSuperLight};
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
`
